// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__Lk0mT","filesListContainer":"PosDisputesFiles_filesListContainer__2K_hP","filesButton":"PosDisputesFiles_filesButton__AQXvp"};